import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import {setPageNewItem} from "@/utils";
import './index.scss'
import { getStorage,gotonext} from "@/utils";import {
  refreshMenu,
} from "../../../../../../redux/common/action";
import {getInfo} from "../../../../../../servers/menuAPI";
import {savedata} from "../../../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal} from "antd";
import {dpeannexdefmap} from "../../../../../../utils/dpedatadef";

@CBaseComponent
class Goodsprotect extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onChange = this.onChange.bind(this)
  }


  state = {
    data: storeManageListNewData,
  }
  onChange(value){
    const data = this.state.data
    data[0].data.forEach((item,index)=>{
      if (item.id === value.data.id) {
        item.value = value.value
      }
    })
    this.setState({
      data:data
    })
  }
  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
      if (item.id === data.id){
        item.ifEdit = !item.ifEdit
        if (data.hasupload!== '') {
          d.forEach(item1=>{
            if (item1.id === data.hasupload){
              item1.ifEdit = !item1.ifEdit
            }
          })
        }
      }
    })
    this.setState({
      data:result
    })
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'1.2.4'
    }
    getInfo(params).then(res=>{
            if (res.pagetips) {
        const data = this.state.data
        data[0].pagetips = res.pagetips
        this.setState({
          data:data
        })
      } else {
        const data = this.state.data
        data[0].pagetips = ''
        this.setState({
          data:data
        })
      }
      const data = []
      res.records.forEach((item,index)=>{
        const obj = {}
        obj.id = item.code
        obj.name = item.name
        obj.placeholder=''
        obj.type= item.type === '1G10' ? 'input':'textarea'
        obj.zhengshu1= index === 0 || index === 1?true:false
        obj.checkType= item.minlimit > 0 ? 'required' : ''
        obj.newDisabled=false
        obj.editDisabled=false
        obj.newShow=true
        obj.editShow=true
        obj.ifEdit=item.type === '1G10' && item.annuname !=='' ? true : false
        obj.value= item.fillin ? decodeURIComponent(item.fillin): ''
        obj.options=[]
        obj.expand = {
          autosize: {minRows: 4, maxRows: 10}
        }
        obj.hasupload = ''
        obj.jpath = item.code
        obj.tips = item.formtips
        obj.showeditbtn = item.type === '1G10' && item.annuname!=='' ? true : false
        data.push(obj)
        if (item.annexdefids !== '' && item.annexdefids!==undefined) {
          const arr = item.annexdefids.split(',')
          arr.forEach(item1=>{
            const info = JSON.parse(JSON.stringify(dpeannexdefmap[item1]))
            const d = {
              id: info.id,
              name: '附件'+info.id+'.'+info.name,
              placeholder: '',
              type: 'img',
              checkType: '',
              newDisabled: false,
              editDisabled: false,
              newShow: true,
              editShow: true,
              value: item.annexlist,
              options: [],
              jpath:info.id,
              expand: {
                limit: 100
              },
              btnname: '附件',
            }
            data.push(d)
          })
        }
      })
 const obj = JSON.parse(JSON.stringify(this.state.data))
      obj[0].data = data
      this.setState({
        data:obj
      })
      const element = document.getElementById('top');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
      }
    })
  }

  onSubmit(data){
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler(data)
      }
    })
  }

  //下一步
  onCancel(data){
    Modal.confirm({
      content: '确认提交数据到下一个填报页面?',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        this.onSubmitHandler(data,'tz')
      }
    })
  }

  onSubmitHandler(data, type=''){
    if (data.status){
      for (let key in data.data) {
        if (typeof data.data[key] !== 'string' && typeof data.data[key] !== 'number'){
          delete data.data[key]
        }
      }
      const params = JSON.parse(JSON.stringify(data.data))
      params.annual = localStorage.getItem('year')
      savedata(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
           if (type === 'tz'){
            gotonext()
            this.props.history.push({
              pathname: '/informationDeclaration/standardManage/open/infomations',
            });
          }
        } else {
          message.error(res.statemessage);
        }
      })
    }
  }

  componentDidMount(){
    this.onSelect()
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <CPageNew
            data={this.state.data}
            onChange={this.onChange}
            onSearch={this.onSearch}
            onSubmit={this.onSubmit}
onCancel={this.onCancel}
            onChangeEdit={this.onChangeEdit}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Goodsprotect);

